module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_lillaedet-4ac2456b45747bcb35f328be71ed294d.png";